<script>
    export default {
        props: {
            answer: {
                type: Boolean,
                default: false,
            },
            id: {
                type: String,
                required: true,
            },
            title: {
                type: String,
                default: '',
            },
            text: {
                type: String,
                default: '',
            },
        },
        data() {
            return {
                show: false,
            };
        },
    };
</script>

<template>
    <div class="dropdown" 
         @mouseenter="show = true" 
         @mouseleave="show = false">
        <div :class="['dropdown-trigger', answer ? 'dropdown-trigger--answer' : 'ml-3']"
             aria-haspopup="true"
             :aria-controls="`dropdown-${id}`">
            <span class="icon is-clickable has-text-link" tabindex="0">
                <i class="fa-solid fa-circle-info"></i>
            </span>
        </div>
        <transition name="transition-zoom-fade">
            <div v-if="show" 
                 :class="['dropdown-menu is-block', {'dropdown-menu--answer': answer }]" 
                 :id="`dropdown-${id}`" 
                 role="tooltip">
                <div class="dropdown-content is-relative">
                    <div class="dropdown-item">
                        <h4 class="title is-5 mb-2">
                            <span class="icon has-text-link mr-3"><i class="fa-solid fa-circle-info"></i></span>
                            <span v-if="title" class="has-text-text">{{ title }}</span>
                        </h4>
                        <div v-if="text" 
                             v-html="text" 
                             class="content has-text-weight-normal"></div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>
